import ReactGA from 'react-ga4';
import { ampli } from '../../ampli';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { setRNMessageReceiver } from '../../utils/RNCommunicator/setRNMessageReceiver.util';
import { usePutUsersMeMutation } from '../api/user/mutations/usePutUsersMe.mutation';

const requestPushAlarmPermission = () => {
  const onMessageHandler = async (e: any) => {
    // React Native가 보내오는 푸시 알람 permisssion 값
    const result = await JSON.parse(e.data);

    // 만약 푸시 알람이 허용된 상태라면, 플레어레인 상에서 해당 기기를 Subscribe 처리
    if (result === true) {
      postMessageToRN({ messageKey: 'flarelane_subscribe', messageParam: 'true' });
    }
  };

  setRNMessageReceiver({ messageHandler: (e) => onMessageHandler(e) });
  postMessageToRN({ messageKey: 'permission', messageParam: 'push' });
};

type PageType = 'TLP' | 'TDP' | 'PLP' | 'PDP' | 'OLP' | 'MY';
interface IUpdateAdConsentParams {
  isAgreeing: boolean;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const useAdvertisementConsent = (pageType: PageType) => {
  const { mutate: putUsersMe } = usePutUsersMeMutation();
  const updateAdConsent = ({ isAgreeing, onSuccess, onError }: IUpdateAdConsentParams) => {
    ampli.pvmClickSetAlarm({ page_type: pageType });
    ReactGA.event('pvm_click_set_alarm_button', {
      category: 'pvm',
      action: 'pvm_click_set_alarm_button',
      page_type: pageType,
    });

    putUsersMe(
      { reqBody: { advertisementTermsAgreement: isAgreeing } },
      {
        onSuccess: () => {
          if (isAgreeing && window.ReactNativeWebView) {
            requestPushAlarmPermission();
          }

          onSuccess?.();
        },
        onError,
      },
    );
  };

  return updateAdConsent;
};
